import { SearchBox as HeadlessSearchBox } from '@coveo/headless';
import React from 'react';
import { useEffect, useState, FunctionComponent } from 'react';

interface SearchBoxProps {
	controller: HeadlessSearchBox;
	secondController?: HeadlessSearchBox;
}

export const SearchBox: FunctionComponent< SearchBoxProps > = ( props ) => {
	const { controller, secondController } = props;
	const [ state, setState ] = useState( controller.state );

	useEffect( () => controller.subscribe( () => setState( controller.state ) ), [] );

	return (
		<form
			className="coveo-standalone-searchbox__form"
			onSubmit={ (e) => {
				e.preventDefault();
				window.location.href = `${ window.location.origin }/search/advanced${ window.location.hash }`;
			} }
		>
			<label className="coveo-standalone-searchbox__search">
				<input
					type="text"
					placeholder="Search..."
					value={ state.value }
					list="coveo-standalone-datalist"
					onChange={ ( e ) => {
						controller.updateText( e.target.value );
						controller.submit();
					} }
				/>
				<button
					type="submit"
				>
					<svg
						className="svg svg--svg-assets-svg-icon-search"
						role="img"
						focusable="false"
						height="24"
						width="24"
						aria-labelledby="svg-assets-svg-icon-search-title"
					>
						<title id="svg-assets-svg-icon-search-title">Search</title>
						<use xlinkHref="#svg-assets-svg-icon-search"></use>
					</svg>
				</button>
			</label>
			<datalist id="coveo-standalone-datalist">
				{ state.suggestions.map( ( suggestion ) => {
					const value = suggestion.rawValue;

					return (
						<option
							key={ value }
							onClick={ () => controller.selectSuggestion( value ) }
							className="coveo-standalone-searchbox__autocomplete-item"
						>
							{ value }
						</option>
					);
				} ) }
			</datalist>
			<button
				type="submit"
				className="coveo-standalone-searchbox__advanced"
			>
				<span>
					Advanced Search
				</span>
				<svg
					className="svg svg--svg-assets-svg-icon-search"
					role="img"
					focusable="false"
					height="24"
					width="24"
					aria-labelledby="svg-assets-svg-icon-arrow-right-wide-title"
				>
					<title id="svg-assets-svg-icon-arrow-right-wide">{ ">" }</title>
					<use xlinkHref="#svg-assets-svg-icon-arrow-right-wide"></use>
				</svg>
			</button>
		</form>
	);
};

// usage

/**
 * ```tsx
 * const options: SearchBoxOptions = {numberOfSuggestions: 8};
 * const controller = buildSearchBox(engine, {options});
 *
 * <SearchBox controller={controller} />;
 * ```
 */
